var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Axios from 'axios';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetOneUserPasswordReset } from '@/actions/PasswordActionsTs';
import { PasswordResetEditViewSkeleton } from '@/components/pages/password/PasswordResetEditView';
import { notify } from '@/helpers/action';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useBoolState } from '@/hooks/state/useBoolState';
import { PasswordResetEditPage } from '@/pages/password/PasswordResetEdit/PasswordResetEditPage';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { NOT_FOUND, BAD_RESET_TOKEN_EXPIRED, } from '@/utils/constants/api/responseCode';
import { passwordResetPath, topPath } from '@/utils/router/links';
/**
 * パスワード再設定（認証以外のアクセス制限）
 */
export const PasswordResetEdit = (props) => {
    var _a;
    const { match } = props;
    const token = ((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.token) || '';
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const history = useNavigate();
    // ローディング制御
    const { boolState: isCheckLoading, changeFalse: stopCheckLoading, changeTrue: startCheckLoading, } = useBoolState();
    // トークン有効判定処理 実行
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            startCheckLoading();
            try {
                const data = { path: { token } };
                yield wrapDispatch(dispatch, apiGetOneUserPasswordReset(data, {}));
            }
            catch (error) {
                if (unmountRef.current) {
                    return;
                }
                if (Axios.isAxiosError(error)) {
                    const errorCode = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code;
                    // 該当ページがない（再設定済 等）の場合
                    if (errorCode === NOT_FOUND) {
                        history.push(topPath());
                    }
                    // トークン切れの場合
                    if (errorCode === BAD_RESET_TOKEN_EXPIRED) {
                        notify('URLの有効期限が切れています。再発行してください');
                        history.push(passwordResetPath());
                    }
                }
            }
            finally {
                if (!unmountRef.current) {
                    stopCheckLoading();
                }
            }
        }))();
    }, [
        dispatch,
        history,
        startCheckLoading,
        stopCheckLoading,
        token,
        unmountRef,
    ]);
    if (isCheckLoading) {
        return _jsx(PasswordResetEditViewSkeleton, {});
    }
    return _jsx(PasswordResetEditPage, { match: match });
};
